import { IEventrActivity, ITodoList } from '@eventr/common'
import { useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useBoundStore } from '../../../state/bound.store'
import {
    selectAllPublishedTodos,
    selectPendingTodoCount,
} from '../../../state/itineraryState/currentItin.slice'

export const usePendingTodoCount = (todoList: ITodoList) => {
    const pendingCount = useMemo(() => {
        return selectPendingTodoCount(useBoundStore.getState(), todoList)
    }, [todoList])

    return pendingCount
}

export const useTotalPendingTodoCount = () => {
    const { todos } = useBoundStore(
        useShallow((s) => {
            return {
                todos: s.itineraryComponents.todos,
            }
        })
    )
    const pendingCount = useMemo(() => {
        return todos.reduce((total, todo) => {
            // Calculate pending count for each todo list
            const pendingCount = selectPendingTodoCount(
                useBoundStore.getState(),
                todo
            )
            return total + pendingCount
        }, 0)
    }, [todos])

    return pendingCount
}
export const useTotalAllPendingTodoCount = (todos?: IEventrActivity[]) => {
    const allTodos = useBoundStore(selectAllPublishedTodos)
    const todosToUse = todos ?? allTodos
    const pendingCount = useMemo(() => {
        return todosToUse.reduce((total: any, todo: any) => {
            // Calculate pending count for each todo list
            const pendingCount = selectPendingTodoCount(
                useBoundStore.getState(),
                todo
            )
            return total + pendingCount
        }, 0)
    }, [todosToUse])

    return pendingCount as number
}
